module.exports = __webpack_public_path__ + "img/6_36.ebf7a51b.png";